import { tryCatch } from 'src/utils/tryCatch';

/** FacebookPixelManager */
export const trackPartnerEvent = (type: string): void => {
  tryCatch(() => {
    window.RallyUp.FacebookPixelManager.TrackPartnerEvent(type);
  }, "couldn't track event: ");
};
